import 'core-js';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import { IntlProvider, LocalizationProvider } from "@progress/kendo-react-intl";

import store from './Store/store';
import App from './App';

import { LanguageJP, LocaleJP } from './Constants/ConstantsValue';
import './index.css';


ReactDOM.render(
  <Provider store={store}>
    <CookiesProvider>
      <LocalizationProvider language={LanguageJP}>
        <IntlProvider locale={LocaleJP}>
          <App />
        </IntlProvider>
      </LocalizationProvider>
    </CookiesProvider>
  </Provider>,

  document.getElementById('root')
);
